import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { href: "#hero", label: "Feast" },
  { slug: "starters", label: "Starters" },
  { slug: "mains", label: "Main Course" },
  { slug: "biryani", label: "Biryani & Breads" },
  { slug: "chinese", label: "Chinese" },
  { href: "#contact", label: "Visit" },
];

export default function Navbar({ info, onSelectCategory }) {
  const [open, setOpen] = useState(false);

  const go = (link) => {
    setOpen(false);
    if (link.slug) onSelectCategory?.(link.slug);
  };

  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-[#0B1319]/90 backdrop-blur-md border-b border-[#1E313D]"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-3" data-testid="nav-brand">
          <div className="w-9 h-9 rounded-full bg-gradient-to-tr from-[#D4AF37] to-[#F7D774] flex items-center justify-center text-[#0B1319] font-serif font-bold text-lg shadow-sm">
            A
          </div>
          <div>
            <span className="font-display text-lg font-bold tracking-wider text-[#F7D774] block leading-none">
              {info?.name || "AL-HAMEEDIYA"}
            </span>
            <span className="text-[10px] tracking-widest uppercase text-[#A8B8C0]">
              {info?.location || "Nagpur, Maharashtra"}
            </span>
          </div>
        </a>
        <div className="hidden md:flex items-center gap-8 text-sm text-[#A8B8C0]">
          {NAV_LINKS.map((link) =>
            link.slug ? (
              <button
                key={link.slug}
                onClick={() => onSelectCategory?.(link.slug)}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s|&/g, "-")}`}
                className="nav-link hover:text-[#F7D774] transition-colors"
              >
                {link.label}
              </button>
            ) : (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s|&/g, "-")}`}
                className="nav-link hover:text-[#F7D774] transition-colors"
              >
                {link.label}
              </a>
            )
          )}
        </div>
        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-dinein-btn"
            className="hidden sm:inline-block px-5 py-2 text-xs font-semibold uppercase tracking-wider bg-gradient-to-r from-[#D4AF37] to-[#C29B27] text-[#0B1319] rounded-sm hover:brightness-110 transition"
          >
            Dine In Info
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle navigation menu"
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-sm border border-[#1E313D] text-[#F7D774] hover:border-[#D4AF37]/60 transition-colors"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[#1E313D] bg-[#0B1319]/98 px-6 py-5 flex flex-col gap-4 text-sm text-[#A8B8C0]"
        >
          {NAV_LINKS.map((link) =>
            link.slug ? (
              <button
                key={link.slug}
                onClick={() => go(link)}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s|&/g, "-")}`}
                className="text-left hover:text-[#F7D774] transition-colors"
              >
                {link.label}
              </button>
            ) : (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s|&/g, "-")}`}
                className="hover:text-[#F7D774] transition-colors"
              >
                {link.label}
              </a>
            )
          )}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-1 inline-block w-fit px-5 py-2 text-xs font-semibold uppercase tracking-wider bg-gradient-to-r from-[#D4AF37] to-[#C29B27] text-[#0B1319] rounded-sm"
          >
            Dine In Info
          </a>
        </div>
      )}
    </nav>
  );
}
